module.exports = __webpack_public_path__ + "img/minicertificate.23e0c235.svg";